module.exports = __webpack_public_path__ + "img/credit-card-gold.7927714b.svg";